/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_Step1_TitleInputs */

const et_process_step1_title = /** @type {(inputs: Process_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01. Tasuta Analüüs`)
};

const en_process_step1_title = /** @type {(inputs: Process_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01. Free Analysis`)
};

/**
* | output |
* | --- |
* | "01. Free Analysis" |
*
* @param {Process_Step1_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_step1_title = /** @type {((inputs?: Process_Step1_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_Step1_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_step1_title(inputs)
	return en_process_step1_title(inputs)
});